import {MasaAugaService} from "../../../service";

import {SearchAutocomplete} from "base/component/search";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const MasaAugaFormSearch = ({
    handleSelect = null,
    name = null,
    rules = {},
    disabled = false,
}) => {
    const optionComponent = option => {
        return (
            <Stack>
                <Typography>{option.codigo}</Typography>
                <Typography variant="caption" sx={{ml: 1}}>
                    {option.nome}
                </Typography>
            </Stack>
        );
    };

    return (
        <SearchAutocomplete
            name={name}
            label="Bacía"
            optionLabelAttribute="codigo"
            optionLabelSecondAttribute="nome"
            optionComponent={optionComponent}
            search={MasaAugaService.getBySearchText}
            handleSelect={handleSelect}
            rules={rules}
            disabled={disabled}
        />
    );
};

export default MasaAugaFormSearch;
